import { Tag } from 'antd';
import UserAvatar from 'components/user-avatar';
import VerifiedTick, { VerifiedBadge } from 'components/verified-tick';
import { MEMBER_ROLE_LABELS } from '../../membership-labels';
import styles from './member-modal.module.scss';

/** Đầu popup Sửa: ai đang được sửa + trạng thái; tích đứng sau @ID như trong app. */
export default function MemberHeader({
  id,
  nickName,
  username,
  avatar,
  role,
  badge,
  verified,
  locked,
  hpStaff,
}: {
  id: number;
  nickName: string;
  username: string;
  avatar?: string | null;
  role?: string;
  badge: VerifiedBadge | null;
  verified: boolean;
  locked: boolean;
  hpStaff: boolean;
}) {
  return (
    <div className={styles.header}>
      <UserAvatar size={52} src={avatar} alt="" className={styles.avatar} />
      <div className={styles.headerText}>
        <div className={styles.headerName}>{nickName || '(Chưa có tên)'}</div>
        <div className={styles.headerId}>
          {username ? <span className={styles.ellipsis}>@{username}</span> : null}
          <VerifiedTick badge={badge} size={15} />
          <span className={styles.dim}>
            {username ? '· ' : ''}ID {id}
          </span>
        </div>
        <div className={styles.headerTags}>
          {role ? <Tag>{MEMBER_ROLE_LABELS[role] || role}</Tag> : null}
          <Tag color={verified ? 'success' : 'warning'}>
            {verified ? 'Đã xác minh email' : 'Chưa xác minh email'}
          </Tag>
          {locked ? <Tag color="error">Đang khoá</Tag> : null}
          {hpStaff ? <Tag color="purple">Nhân viên HP</Tag> : null}
        </div>
      </div>
    </div>
  );
}
